import { useQuery } from "urql";

import {
  GetTradeInsuranceNamesDocument,
  TradeInsuranceFilter,
  TradeInsuranceOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const useTradeInsuranceNames = ({
  filter,
  orderBy,
  page,
}: ApiHookProps<TradeInsuranceFilter, TradeInsuranceOrderBy>) => {
  const pagination = getApiPaginationData(page);
  return useQuery({
    query: GetTradeInsuranceNamesDocument,
    variables: {
      filter,
      orderBy,
      skip: pagination?.skip,
      take: pagination?.take,
    },
  });
};
